module.exports = __webpack_public_path__ + "img/newheader.9abfcf82.jpg";